import type { NumberValueSubtypeSpec } from "../valueSubtypeSpecs.ts";

/**
 * Reading a number spec, in its own module because both the number definition
 * and the Comparison View need it, and the definition already imports the view —
 * the view calling back into the definition would close the cycle.
 */

/** The literal a bounded number falls back to: the bottom of its range, since zero may sit outside it. */
export const defaultNumberLiteral = (spec?: NumberValueSubtypeSpec): number => spec?.min ?? 0;

/** A stored number as the author reads it, shifted by the spec's display offset. */
export const displayNumberLiteral = (value: number, spec?: NumberValueSubtypeSpec): string =>
  String(value + (spec?.offset ?? 0));
